module.exports = __webpack_public_path__ + "img/M400.26283b6.jpg";